import * as React from 'react';
import { connect } from 'react-redux';
import { renderCheckbox } from '../../common/forms/FieldCreators';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import { Form, Control, Fieldset } from 'react-redux-form';
import { OnSubmitFormProps } from '../../common/props/commonFormProps';
import { ContactFormGroup } from '../../common/forms/ContactFormGroup';
import { ApplicationState } from '../../store';
import { FirstLastNameFormGroup } from '../../common/forms/PersonFormGroup';
import { localizations } from '../../localization/localization';
import FormItem from '../../components/forms/FormItem';
import pdf from '../privacy/Kayttoehdot-UnitSpotter_20180925.pdf'
import gdpr from '../privacy/Tietosuojaseloste-UnitSpotter.pdf'

const formName = "registerCompanyContactForm";

const styles = (theme: Theme) => ({
    buttons: {
        marginRight: theme.spacing(2),
        marginLeft: theme.spacing(2),
    }
});

export interface TermsAcceptedState {
    termsAccepted: boolean;
}

export interface RegisterContactPersonModel extends TermsAcceptedState {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
}

export interface RegisterCompanyContactFormProps {
    onPreviousClick: (e: object) => void
}


// Create terms label with links.
const termsLabel = <div className="privacyLabel">
    {localizations.company.accept} <a href = {pdf} target = "_blank">{localizations.company.termsOfUse}</a>
</div >;

const consentForm = <div>
    {localizations.register.privacy} <a href = {gdpr} target = "_blank">{localizations.register.privacyPolicy}</a>
</div >;

export type RegisterCompanyContactPersonFormProps = WithStyles<"buttons"> & OnSubmitFormProps<any> & TermsAcceptedState & RegisterCompanyContactFormProps;

const RegisterCompanyContactForm: React.StatelessComponent<RegisterCompanyContactPersonFormProps> = (props: any) => {
    const { termsAccepted, onPreviousClick, onSubmit, classes } = props;
    return (<div>
        <Typography variant="body2">{localizations.register.registerCompanyStepTwo}</Typography>
        <Form hideNativeErrors model="registerCompanyModel" onSubmit={onSubmit}>
            <FirstLastNameFormGroup modelBase=".contactPerson" />
            <Fieldset model=".contactPerson">
                <ContactFormGroup />
            </Fieldset>
            <FormItem>
                <FormControlLabel label={termsLabel} control={<Control.checkbox model=".termsAccepted" id="termsAccepted" component={renderCheckbox} />} />
                <Typography> {consentForm} </Typography>
                <br />
                <br />
                <FormItem>
                        <Grid container direction="row" spacing={4} justify="center">
                            <Grid item><Button variant="contained"color="secondary" onClick={onPreviousClick}>{localizations.actions.previous}</Button></Grid>
                            <Grid item><Button variant="contained" disabled={!termsAccepted} color="primary" type="submit">{localizations.actions.register}</Button></Grid>
                        </Grid>
                </FormItem>
            </FormItem>
        </Form>
    </div>
    );
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        termsAccepted: state.forms.registerCompanyModel.termsAccepted.value
    }
}

export default withStyles(styles)(connect<TermsAcceptedState>(mapStateToProps)(RegisterCompanyContactForm));


// WEBPACK FOOTER //
// ./src/register/company/RegisterCompanyContactForm.tsx